export default __webpack_public_path__ + "static/media/loading.384ccac7.svg";